<template>
<div>
    <v-server-table :name="tableName" :ref="tableName" :url="'/employees/recognition-list'" :columns="columns" :options="options">

        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
            <div class="clearfix d-md-none d-block"></div>

            <div class="float-left">
                <table-filters-2 ref="empRecogTableFilters" v-bind:filters="filters" filterUrl="/employees/recognition/filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                    <template slot-scope="slotProps">
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['employee_recognitions.recognition_id']" :btnLabel="(values) => ('Recognition Types ('+values.length+')')" :selectOptions="slotProps.filterData.recognitions" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <date-range-selector buttonTitle="Recognition Date" v-model="slotProps.filters['employee_recognitions.recognition_date']" />
                        </div>
                        <div class="d-inline-block" style="width: 300px;">
                            <jobsite-select :selectedValues="slotProps.filters['employee_recognitions.jobsite_id']" :forFilters="true" v-on:vselected="((data) => { slotProps.filters['employee_recognitions.jobsite_id'] = data || {};  })" />
                        </div>
                        <hr/>

                        <div class="d-inline-block" style="width: 250px">
                            <employee-select :forFilters="true" :selectedValues="slotProps.filters['employee_recognitions.employee_id']"  v-on:vselected="((data) => { slotProps.filters['employee_recognitions.employee_id'] = data || {};  })"></employee-select>
                        </div>
                        <div class="d-inline-block" style="width: 250px">
                            <employee-select :forFilters="true" :selectedValues="slotProps.filters['employee_recognitions.supervisor_id']" v-on:vselected="((data) => { slotProps.filters['employee_recognitions.supervisor_id'] = data || {};  })" placeholder="Superintendents"></employee-select>
                        </div>
                        <div class="d-inline-block" style="width: 250px">
                            <employee-select :forFilters="true" :selectedValues="slotProps.filters['employee_recognitions.foreman_id']" v-on:vselected="((data) => { slotProps.filters['employee_recognitions.foreman_id'] = data || {};  })" placeholder="Foremen"></employee-select>
                        </div>
                    </template>
                </table-filters-2>
            </div>

            <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportRecognitions()"><i class="fa fa-file-excel-o"></i> Export</button>

            <div class="clearfix d-md-none d-block"></div>
        </div>

        <template slot="employee_recognition_id" slot-scope="props">
            <router-link :to="`/employees/recognition/view/${props.row.employee_recognition_id}`" class="btn btn-sm btn-secondary">
                View
            </router-link>
        </template>
        <template slot="creator_first_name" slot-scope="props">
            {{ props.row.creator_first_name }} {{ props.row.creator_last_name }}
        </template>
        <template slot="super_last_name" slot-scope="props">
            <template v-if="props.row.super_last_name">{{ props.row.super_first_name }} {{ props.row.super_last_name }}</template>
        </template>
        <template slot="foreman_last_name" slot-scope="props">
            <template v-if="props.row.foreman_last_name">{{ props.row.foreman_first_name }} {{ props.row.foreman_last_name }}</template>
        </template>
        <router-link :to="`/employees/view/${props.row.employee_id}`" slot="employee_last_name" slot-scope="props">
            {{ props.row.EmployeeNumber }} - {{ props.row.employee_first_name }} {{ props.row.employee_last_name }}
        </router-link>
        <template slot="JobsiteName" slot-scope="props">
            <router-link :to="`/jobsites/view/${props.row.jobsite_id}`" v-if="props.row.JobsiteName">{{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}</router-link>
            <span v-else></span>
        </template>
        <template slot="recognition_date" slot-scope="props">
            {{ props.row.recognition_date | moment("MM/DD/YYYY") }}
        </template>
        <template slot="status" slot-scope="props">
            <span v-if="props.row.status == 'Open'" class="badge badge-danger">{{ props.row.status }}</span>
            <span v-if="props.row.status == 'Closed'" class="badge badge-success">{{ props.row.status }}</span>
        </template>

        <template slot="child_row" slot-scope="props">
            <div class="mb-2">
                <div class="text-muted">Explanation:</div>
                <template v-if="!props.row.explanation">
                    --
                </template>
                <template v-else>
                    {{ props.row.explanation }}
                </template>
            </div>
            <div class="mb-2">
                <div class="text-muted">General Comments:</div>
                <template v-if="!props.row.general_comments">
                    --
                </template>
                <template v-else>
                    {{ props.row.general_comments }}
                </template>
            </div>

        </template>
    </v-server-table>
</div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                type: Number,
                default: null,
            },

            saveState: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                exportingTable: false,
                tableName: 'recognitionsTable',

                columns: [
                    'employee_recognition_id',
                    'employee_last_name',
                    'craft',
                    'creator_first_name',
                    'recognition_name',
                    'super_last_name',
                    'foreman_last_name',
                    'JobsiteName',
                    'DivisionName',
                    'recognition_date',
                    'status',
                ],

                filterKey: 'empRecogFilters',

                filterDefs: {
                    'employee_recognitions.recognition_id': [],
                    'jobsite.DivisionId': [],
                    'employee_recognitions.recognition_date' : '',
                    'employee_recognitions.employee_id': {},
                    'employee_recognitions.supervisor_id': {},
                    'employee_recognitions.foreman_id': {},
                    'employee_recognitions.jobsite_id': {},
                }
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        employee_recognition_id: 'Actions',
                        employee_last_name: 'Employee',
                        craft: 'Craft',
                        creator_first_name: 'Creator',
                        recognition_name: 'Recognition Type',
                        super_last_name: 'Superintendent',
                        foreman_last_name: 'Foreman',
                        JobsiteName: 'Jobsite',
                        DivisionName: 'Division',
                        recognition_date: 'Date',
                        status: 'Status',
                    },
                    saveState: this.saveState,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.saveState ? this.$root.getVisibleColumnsFromState(this.tableName) : false),
                    orderBy: {
                        ascending: false,
                        column: 'employee_recognitions.recognition_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('recognitionListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //INclude the asset
                        data.asset_type = this.assetType;
                        data.asset_id = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'employee_recognition_id',
                };
            },
        },

        methods: {
            creator(row) {
                return {
                    FirstName: row.creator_first_name,
                    LastName: row.creator_last,
                    deleted_at: row.creator_deleted_at,
                };
            },

            exportRecognitions(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.recognitionsTable.getRequestParams()).query,
                    orderBy: this.$refs.recognitionsTable.options.orderBy.column,
                    ascending: this.$refs.recognitionsTable.options.orderBy.ascending,
                    columns: this.$refs.recognitionsTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    asset_id: this.assetId,
                    asset_type: this.assetType,
                    table: 'employee-recognitions-table',
                    export: true,
                };

                //Send it
                this.$http.post('/employees/recognition-list', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {})
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.recognitionsTable.setPage(1);
                this.$refs.recognitionsTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.empRecogTableFilters.resetColVis(this.$refs.recognitionsTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.empRecogSavedFilters.setFilterParams(this.$refs.recognitionsTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.empRecogTableFilters.setColVis(this.$refs.recognitionsTable);
            },
        },

        mounted(){
            //Check for a saved filter
            this.checkForAppliedFilter();
        }
    }
</script>
